import {Component, EventEmitter, Input, Output, signal} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-sales-additional-information-field-radio',
  templateUrl: './sales-additional-information-field-radio.component.html'
})
export class SalesAdditionalInformationFieldRadioComponent {
  @Input() form!: FormGroup;
  @Input() field: any;
  @Input() variant: 'v2' | 'v3' = 'v2';
  @Output() saveEvent = new EventEmitter();
  isSubmitting = signal(false);

  ngOnInit() {
    this.form.addControl(`${this.field.key}`, new FormControl(this.field.value, [Validators.required]));
  }

  save() {
    this.isSubmitting.set(true);
    if(this.form.get(this.field.key)?.errors === null) {
      this.saveEvent.emit({id: this.field.id, value: this.form.get(this.field.key)?.value});
    }
  }

  get f() {
    return this.form.controls;
  }
}
